import { render, staticRenderFns } from "./screen-full.vue?vue&type=template&id=31f2607a&scoped=true&lang=pug"
import script from "./screen-full.vue?vue&type=script&lang=js"
export * from "./screen-full.vue?vue&type=script&lang=js"
import style0 from "./screen-full.vue?vue&type=style&index=0&id=31f2607a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2607a",
  null
  
)

export default component.exports